module.exports = __webpack_public_path__ + "img/notification.eda024fc.svg";